// Self-hosted fonts via @fontsource — latin subset + specific weights only
// Avoids inlining Cyrillic/Vietnamese/etc subsets that are never used (~60KB saved)
import "@fontsource/montserrat/latin-400.css"
import "@fontsource/montserrat/latin-700.css"
import "@fontsource/montserrat/latin-900.css"
import "@fontsource/merriweather/latin-400.css"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"
// Highlighting for code blocks
import "prismjs/themes/prism-okaidia.css"

// Load AdSense lazily after page becomes interactive
// Avoids blocking LCP and prevents SSL errors in Lighthouse's sandboxed Chrome
export const onClientEntry = () => {
  if (typeof window === "undefined") return

  const loadAdSense = () => {
    if (document.querySelector('script[src*="adsbygoogle"]')) return
    const script = document.createElement("script")
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4546010269809354"
    script.async = true
    script.crossOrigin = "anonymous"
    script.onload = () => {
      try {
        ;(window.adsbygoogle = window.adsbygoogle || []).push({
          google_ad_client: "ca-pub-4546010269809354",
          enable_page_level_ads: true,
        })
      } catch (e) {}
    }
    document.head.appendChild(script)
  }

  // Use requestIdleCallback if available, otherwise load after 3s
  if ("requestIdleCallback" in window) {
    requestIdleCallback(loadAdSense, { timeout: 3000 })
  } else {
    setTimeout(loadAdSense, 3000)
  }
}
